// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// utilities
import _ from 'lodash';
import cx from 'classnames';
import { Scrollspy } from 'react-scrollspy';


@connect((store, props) => {
  const searchQuery = store.routing.locationBeforeTransitions.query.search;
  return {
    search: searchQuery && [].concat(searchQuery) || []
  };
})
export default class ScrollColumn extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    navGroups: PropTypes.array.isRequired,
    title: PropTypes.string
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className='scroll-column'>
        <h3>{this.props.title}</h3>
        <Scrollspy items={this.props.navGroups} currentClassName='active'>
          {
            this.props.navGroups.map((section, index) =>
              <li>
                <a href={`#${section}`}><div className='label'>{_.replace(section, new RegExp("_", "g"), " ")}</div></a>
              </li>
            )
          }
        </Scrollspy>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/ScrollColumn/index.js